import Layout from "../components/Layout";
import { kebijakanPrivasiMeta, defaultURL } from "../data/DataMetatags";
import NextHead from "../components/Seo/NextHead";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { kebijakanPrivasiBreadcrumb } from "../data/DataBreadcrumb";
import { Box, Heading, Text, UIProvider } from "src/components/UI";

const kebijakanPrivasi = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home",
      },
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle,
      },
    },
  ];

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={kebijakanPrivasiBreadcrumb} />

      <UIProvider>
        <Box
          maxWidth={["100%", "1024px"]}
          margin="0 auto"
          padding={["0 16px", "0px"]}
        >
          <Box margin={["0 auto"]} alignItems="center">
            <Heading
              as="h1"
              fontSize={["18px", "24px"]}
              fontWeight={["normal", ""]}
            >
              Kebijakan Privasi
            </Heading>
            <Heading
              as="h1"
              fontSize={["18px", "24px"]}
              fontWeight={["normal", ""]}
            >
              PT Home Credit Indonesia
            </Heading>
          </Box>

          <Text marginBottom={["4px", "8px"]} fontWeight="bold">
            Berlaku sejak: September 2024
          </Text>
          <Text
            marginBottom={["4px", "8px"]}
            textDecoration="underline"
            fontWeight="bold"
          >
            Pendahuluan
          </Text>

          <Box gap={["16px", "16px"]}>
            <Text>
              PT Home Credit Indonesia (“<b>Home Credit</b>” atau "<b>kami</b>
              "), suatu perusahaan pembiayaan yang berizin dan diawasi oleh
              Otoritas Jasa Keuangan (“<b>OJK</b>”), yang mengoperasikan suatu
              situs web, termasuk Aplikasi Seluler ("<b>Aplikasi</b>"). Anda
              adalah pengguna Aplikasi dan/atau penerima fasilitas pembiayaan
              kami (“<b>Anda</b>”, “<b>Pengguna</b>” atau “<b>Konsumen</b>”).
              Kebijakan Privasi ini menginformasikan kepada Anda sekaligus
              menjelaskan bagaimana kami memperoleh, mengumpulkan, menyimpan,
              menguasai, menggunakan, mengolah, menganalisis, memperbaiki,
              melakukan pembaruan, menampilkan, mengumumkan, mengalihkan,
              mengungkapkan dan melindungi  data dan informasi pribadi Anda yang
              Anda berikan ketika mengakses dan/atau menggunakan Aplikasi (“
              <b>Pemrosesan Data Pribadi</b>”).
            </Text>
            <Text>
              Dalam menjalankan dan mengelola Aplikasi dan/atau layanan lainnya
              melalui Aplikasi, Home Credit menerapkan Kebijakan Privasi ini
              untuk menetapkan standar dan tata cara pelindungan Pemrosesan Data
              Pribadi.
            </Text>
            <Text>
              Dengan menyetujui Kebijakan Privasi, Anda mengakui bahwa Anda
              telah membaca dan memahami Kebijakan Privasi ini serta menyetujui
              segala ketentuannya. Secara khusus, Anda sepakat dan memberikan
              persetujuan kepada kami untuk melakukan Pemrosesan Data Pribadi
              Anda sesuai dengan Kebijakan Privasi ini.
            </Text>
          </Box>

          <Box margin={["12px 0 ", "16px 0"]}>
            <ol style={{ marginLeft: "16px" }}>
              <li>
                <Heading margin={["8px 0", "8px 0"]}>
                  <b>Data Pribadi Yang Kami Kumpulkan</b>
                </Heading>
              </li>
              <ol type="a" style={{ marginLeft: "32px" }}>
                <li>
                  <Heading>
                    <b>Definisi Data Pribadi</b>
                  </Heading>
                  <Text>
                    Data Pribadi adalah data tentang orang perseorangan yang
                    teridentifikasi atau dapat diidentifikasi secara tersendiri
                    atau dikombinasi dengan informasi lainnya baik secara
                    langsung maupun tidak langsung, baik yang bersifat spesifik
                    maupun umum termasuk, namun tidak terbatas pada, nama
                    lengkap, nama Pengguna, data dokumen identitas nasional atau
                    tanda pengenal lainnya yang dikeluarkan pemerintah,
                    kewarganegaraan, jenis kelamin, nama ibu kandung, agama,
                    status perkawinan, alamat, alamat surat elektronik (
                    <i>email</i>), pekerjaan, alamat dan/atau nomor telepon
                    tempat kerja/usaha, nama tempat usaha, alamat tempat usaha,
                    surat keterangan pajak, kisaran penghasilan, nomor telepon
                    seluler, tempat dan tanggal lahir, foto (pilihan), data
                    keuangan pribadi dan/atau rekening bank, data biometrik,
                    data kendaraan, termasuk penyediaan data lokasi seperti
                    perkiraan lokasi (berbasis jaringan), kepastian lokasi (
                    <i>global positioning system</i> “<b>GPS</b>” dan berbasis
                    jaringan), informasi dan/atau data lainnya sebagaimana
                    berlaku, serta data lain sesuai dengan ketentuan
                    perundang-undangan yang berlaku, termasuk peraturan
                    perundang-undangan mengenai pelindungan data pribadi, yang
                    Anda serahkan atau sediakan pada saat proses pendaftaran dan
                    selama Anda sudah terdaftar sebagai Pengguna pada Aplikasi.
                    Selain itu, data-data lain, termasuk profil pribadi,
                    dan/atau pengenal unik, dikaitkan atau digabungkan dengan
                    Data Pribadi, maka data tersebut juga merupakan Data
                    Pribadi.
                  </Text>
                  <Text>
                    Jenis Data Pribadi yang Kami kumpulkan bergantung pada
                    keadaan pengumpulan dan sifat layanan yang diminta.
                    Sepanjang diizinkan oleh peraturan perundang-undangan yang
                    berlaku, kami dapat memproses, mengumpulkan, menggunakan,
                    menyimpan dan mentransfer jenis-jenis berbeda dari Data
                    Pribadi tentang Anda.
                  </Text>
                </li>

                <li>
                  <Heading>
                    <b>Data Gabungan</b>
                  </Heading>
                  <Text>
                    Kami dapat membuat, menggunakan, atau mengungkapkan Data
                    Gabungan seperti data statistik atau demografi untuk tujuan
                    apa pun. Data Gabungan dapat berasal dari Data Pribadi Anda,
                    tetapi tidak akan dianggap sebagai Data Pribadi karena data
                    ini tidak akan secara langsung atau tidak langsung
                    mengungkapkan identitas Anda karena Kami akan memastikan:
                    (i) bahwa semua pengenal telah dihapus sedemikian rupa
                    sehingga data, sendiri atau bersama-sama dengan data lain
                    yang tersedia, tidak dapat dikaitkan atau dihubungkan dengan
                    atau tidak dapat mengidentifikasi siapa pun, dan (ii) data
                    tersebut kemudian digabungkan dengan data serupa sehingga
                    data asli membentuk bagian dari kumpulan data yang lebih
                    besar.
                  </Text>
                </li>

                <li>
                  <Heading>
                    <b>Data Yang Kami Kumpulkan Dari Anda Secara Langsung</b>
                  </Heading>
                  <Text>
                    Anda dapat memberikan kepada kami Data Pribadi Anda,
                    termasuk dalam keadaan di mana hal tersebut diminta oleh
                    kami atau dalam keadaan diharuskan oleh peraturan
                    perundang-undangan yang berlaku, saat berinteraksi dengan
                    kami secara langsung atau berkorespondensi dengan kami
                    melalui surat, email atau lainnya. Hal ini termasuk Data
                    Pribadi yang Anda sediakan ketika Anda:
                  </Text>
                  <ol type="i" style={{ marginLeft: "48px" }}>
                    <li>
                      mendaftar dan menggunakan Aplikasi termasuk mengirimkan
                      dokumen, mengunggah dan/atau mengunduh dokumen, mengakses
                      sistem atau aplikasi yang disediakan Home Credit;
                      <li>
                        melakukan pembayaran dengan menggunakan metode yang
                        tersedia; dan
                      </li>
                      <li style={{ overflowWrap: "break-word" }}>
                        menghubungi/berinteraksi/berkorespondensi dengan Kami,
                        layanan pelanggan dan/atau fitur chat kami.{" "}
                      </li>
                    </li>
                  </ol>

                  <Text>
                    Persetujuan penggunaan dan/atau pemrosesan Data Pribadi
                    untuk fasilitas pembiayaan dan pemasaran dan penawaran
                    promosi disetujui terpisah dalam Aplikasi.
                  </Text>
                </li>

                <li>
                  <Heading>
                    <b>
                      Data Yang Kami Kumpulkan Dari Perangkat Selular Pribadi
                      Anda
                    </b>
                  </Heading>
                  <Text>
                    Kami, dengan tujuan untuk dapat memberikan layanan dan/atau
                    keputusan penilaian yang lebih baik pada saat proses
                    pendaftaran, penggunaan Aplikasi atau selama Anda sudah
                    terdaftar sebagai Pengguna pada Aplikasi, akan (1)
                    mengunduh, menyimpan dan/atau menggunakan (a) kepastian
                    lokasi GPS; (b) <i>microphone</i> dan (c) kamera perangkat,
                    dan juga (2) mengunduh, menyimpan dan/atau menggunakan hanya
                    meta informasi (ukuran file, jumlah file, tanggal file
                    dan/atau resolusi) tetapi bukan konten dari: (i) akun dan
                    aplikasi terdaftar dan/atau terpasang pada perangkat,
                    termasuk fitur dan izin-izin yang terdapat di dalam aplikasi
                    tersebut, aktivitas penggunaan aplikasi, serta statistik
                    penggunaan aplikasi, (ii) suara/audio, (iii)
                    panggilan(-panggilan) telepon, (iv) data umum-operator
                    telepon selular dan pengaturan (misal, jaringan operator dan
                    penggunaan jaringan, Wi-Fi, Bluetooth, kota dan kode negara
                    penyedia kartu <i>subscriber identity module</i>
                    /SIM dan seluruh pengaturan dan perizinan seluler), (v)
                    Gmail, (vi) platform, (vii) pengaturan perangkat, (viii)
                    informasi umum mengenai perangkat (misal,{" "}
                    <i>device ID, device info</i>, tipe perangkat (
                    <i>
                      device type), Mobile Country Code, Mobile Network Code
                    </i>
                    , bahasa, negara, zona waktu, jenis <i>keyboard</i>, inisial
                    negara dan bahasa, dan <i>Mobile Equipment Identifier</i>),
                    (ix) layanan pesan singkat/<i>short message service</i> (“
                    <b>SMS</b>”), (x) <i>browsing history</i> dari perangkat
                    Anda, (xi) kontak dan/atau grup kontak, (xii) gambar, (xiii)
                    video, (xiv) kalender, jadwal kalender, peserta yang hadir
                    dan pengingat, (xv) informasi baterai, (xvi) sistem operasi,
                    (xvii) data serta dokumen yang diunduh, (xviii) spesifikasi
                    perangkat keras (<i>hardware</i>), (xix) lokasi, (xx)
                    sensor-sensor pada perangkat, (xxi) informasi jam masuk dan
                    keluar (<i>clock in and out</i>), dan (xxii) informasi
                    terkait <i>library</i>, versi dan kendala dari aplikasi
                    tambahan yang menempel pada Aplikasi Utama.
                  </Text>
                </li>

                <li>
                  <Heading>
                    <b>
                      <i>Log Data</i>
                    </b>
                  </Heading>
                  <Text>
                    Kami mengumpulkan informasi mengenai riwayat laman yang Anda
                    kunjungi (<i>browsing history</i>) termasuk jam, tanggal dan
                    periode <i>browsing</i> Anda. Khususnya informasi yang{" "}
                    <i>browser</i> atau sistem operasi Anda kirimkan setiap kali
                    Anda mengunjungi Aplikasi (<b>catatan data</b> atau{" "}
                    <b>
                      <i>log data</i>
                    </b>
                    ). Catatan data ini dapat mencakup informasi seperti alamat
                    protokol internet (<i>internet protocol</i> atau "<b>IP</b>
                    "), versi dan tipe <i>browser</i> atau sistem operasi,
                    aplikasi yang diinstal, waktu dan tanggal akses masuk anda
                    ke dalam Aplikasi, koordinat GPS, nomor{" "}
                    <i>international mobile equipment identity</i> (IMEI),
                    produsen telepon, model telepon, nomor seri telepon,
                    penyedia data, informasi baterai, informasi dalam memori
                    disk, waktu yang dihabiskan dan statistik lainnya.{" "}
                  </Text>
                </li>

                <li>
                  <Heading>
                    <b>
                      Data yang Tidak Dikumpulkan dalam Perangkat Selular
                      Pribadi Anda
                    </b>
                  </Heading>
                  <Text>
                    Kami tidak akan mengumpulkan data/informasi sebagai berikut:
                    (i) nomor identifikasi pribadi (
                    <i>personal identification number</i>/PIN)/kata sandi
                    perangkat atau informasi lainnya apapun untuk memperoleh
                    akses ke akun anda, (ii) konten apapun dari: pesan teks,
                    SMS, atau <i>email(-email)</i>, foto, jaringan sosial,
                    komunikasi <i>app messenger</i>, dan/atau <i>file(-file)</i>{" "}
                    lainnya apapun dalam selular anda.
                  </Text>
                </li>

                <li>
                  <Heading>
                    <b>Data yang Dikumpulkan dari Pihak Ketiga</b>
                  </Heading>
                  <Text>
                    Kami juga dapat mengumpulkan Data Pribadi Anda dari pihak
                    ketiga (termasuk agen, vendor, pemasok, kontraktor, mitra,
                    institusi pemerintah dan pihak lainnya yang menyediakan
                    layanan kepada Kami, mengumpulkan Data Pribadi dan/atau
                    melakukan tugas atas nama Kami, atau dengan pihak yang
                    melakukan kerja sama dengan Kami). Dalam kondisi tersebut,
                    Kami hanya akan mengumpulkan dan/atau memroses Data Pribadi
                    Anda untuk atau sehubungan dengan tujuan yang melibatkan
                    pihak ketiga tersebut atau tujuan kerja sama Kami dengan
                    pihak ketiga tersebut dan/atau sebagai pemenuhan ketentuan
                    peraturan perundang-undangan yang berlaku.
                  </Text>
                </li>

                <li>
                  <Heading>
                    <b>
                      Data tentang Pihak Ketiga yang Anda Berikan Kepada Kami
                    </b>
                  </Heading>
                  <Text>
                    Anda dapat memberikan kepada Kami Data Pribadi yang
                    berkaitan dengan individu pihak ketiga lainnya (termasuk
                    Data Pribadi yang berkaitan dengan pasangan Anda, anggota
                    keluarga, teman, atau individu lain). Dalam kondisi
                    tersebut, Anda menyatakan dan menjamin bahwa Anda telah
                    mendapatkan persetujuan dari individu pihak ketiga lainnya
                    tersebut, dan dengan ini menyetujui atas nama individu
                    tersebut, untuk Pemrosesan Data Pribadi mereka oleh Kami,
                    Kami dapat meminta bukti dari persetujuan tersebut kepada
                    anda setiap saat.
                  </Text>
                </li>
              </ol>

              <li>
                <Heading margin={["8px 0", "8px 0"]}>
                  <b>Tujuan Penggunaan Data Pribadi Anda</b>
                </Heading>
                <Text>
                  Kami mengumpulkan, menggunakan dan memroses Data Pribadi Anda
                  untuk tujuan sebagai berikut maupun untuk tujuan lain yang
                  diizinkan oleh peraturan perundang-undangan yang berlaku,
                  termasuk namun tidak terbatas pada, peraturan mengenai
                  pelindungan data pribadi (“<b>Tujuan</b>”):
                </Text>

                <ol type="a" style={{ marginLeft: "32px" }}>
                  <li>
                    mengidentifikasi dan mendaftarkan Anda sebagai pengguna
                    Aplikasi dan untuk memverifikasi, menonaktifkan, atau
                    mengelola Aplikasi;
                  </li>
                  <li>
                    dalam hal Anda mengajukan fasilitas pembiayaan atau
                    fasilitas layanan lainnya, Data Pribadi Anda akan digunakan
                    untuk tujuan:
                    <ol type="1" style={{ marginLeft: "32px" }}>
                      <li>
                        memeriksa kelayakan penerimaan fasilitas pembiayaan yang
                        disediakan oleh Kami atau fasilitas layanan yang
                        disediakan oleh Pihak Ketiga yang tersedia dalam
                        Aplikasi, termasuk melakukan proses penilaian kredit (
                        <i>credit scoring</i>) (jika dibutuhkan), pemeriksaan
                        dan/atau verifikasi data atau catatan-catatan dari
                        Sistem Layanan Informasi Keuangan (“<b>SLIK</b>”) atau
                        Lembaga Pengelola Informasi Perkreditan, pihak berwenang
                        lainnya dan/atau sumber informasi publik lainnya, dan
                        upaya pencegahan anti pencucian uang, pencegahan
                        pendanaan terorisme, dan pencegahan pendanaan
                        proliferasi senjata pemusnah massal, melaksanaan
                        strategi <i>anti-fraud</i>, dan melakukan upaya
                        pencegahan <i>fraud</i>, sebagaimana diatur oleh
                        peraturan perundang-undangan yang berlaku;{" "}
                      </li>
                      <li>
                        mengolah dan memfasilitasi layanan pembiayaan, transaksi
                        jasa keuangan lainnya dan transaksi pembayaran yang Anda
                        lakukan, termasuk memfasilitasi dan menyediakan fitur
                        tambahan tertentu yang melekat pada fasilitas
                        pembiayaan;
                      </li>
                    </ol>
                  </li>
                  <li>
                    dalam hal Anda mengajukan permohonan untuk menjadi mitra
                    Kami, Data Pribadi Anda akan digunakan untuk tujuan
                    mendaftarkan Anda sebagai mitra dari Home Credit, mengelola
                    Point of Sales Anda, mendaftarkan karyawan/Retailer Agent
                    Anda sebelum ditugaskan di Point of Sales;
                  </li>
                  <li>
                    memfasilitasi pentautan dengan platform pihak ketiga dalam
                    hal layanan disediakan oleh pihak ketiga; 
                  </li>
                  <li>
                    berkomunikasi dengan Anda dan mengirimkan Anda informasi
                    sehubungan dengan penggunaan Aplikasi (termasuk setiap
                    pemberitahuan yang dipersyaratkan oleh hukum, sebagai
                    pengganti komunikasi dengan surat melalui pos). Apabila Anda
                    tidak ingin menerima pesan-pesan tersebut sebagai pesan yang
                    muncul (pop up) dalam Aplikasi, Anda dapat memilih untuk
                    tidak menerima pesan-pesan tersebut (opt out) dengan
                    mematikan tombol untuk pesan dengan mengikuti petunjuk dalam
                    Aplikasi, akan tetapi, Anda akan tetap menerima pesan
                    tersebut di dalam inbox; 
                  </li>
                  <li>
                    memberitahu Anda mengenai segala pembaruan pada Aplikasi
                    atau perubahan pada layanan yang disediakan;
                  </li>
                  <li>
                    mengolah, memproses, menyelesaikan dan menanggapi keluhan,
                    permasalahan, pertanyaan dan saran yang diterima dari Anda;
                  </li>
                  <li>
                    melakukan pemeliharaan, mengembangkan, menguji,
                    meningkatkan, dan mempersonalisasikan Aplikasi untuk
                    memenuhi kebutuhan dan preferensi Anda sebagai Pengguna;
                  </li>
                  <li>
                    memantau dan menganalisis aktivitas, perilaku, dan data
                    demografis pengguna termasuk kebiasaan dan penggunaan
                    berbagai layanan yang tersedia di Aplikasi;
                  </li>
                  <li>
                    untuk tujuan pengujian, penelitian, analisis, pengembangan
                    produk, kemitraan komersial, dan kerja sama dengan pihak
                    ketiga;
                  </li>
                  <li>
                    Menyimpan atau membuat duplikasi Data Pribadi baik di dalam
                    atau di luar yurisdiksi Anda maupun Home Credit, sepanjang
                    diperbolehkan dan mengikuti serta tunduk pada peraturan
                    perundang-undangan yang berlaku;
                  </li>
                  <li>
                    Menyimpan dan mendokumentasikan seluruh Pemrosesan Data
                    Pribadi yang diwajibkan oleh peraturan perundang-undangan
                    dan/atau sebagai persyaratan penyimpanan Data Pribadi;
                    dan/atau
                  </li>
                  <li>
                    mematuhi semua kewajiban berdasarkan peraturan
                    perundang-undangan yang berlaku dan melakukan pemeriksaan
                    audit (internal dan eksternal), uji tuntas dan dalam rangka
                    penegakan hukum.
                  </li>
                </ol>
              </li>
              <li>
                <Heading margin={["8px 0", "8px 0"]}>
                  <b>Pihak Ketiga</b>
                </Heading>
                <Text>
                  Pihak Ketiga adalah setiap biro informasi kredit yang
                  tersedia, pusat data identitas dari pihak ketiga mana pun yang
                  tersedia sah secara hukum, lembaga keuangan mana pun, setiap
                  otoritas pemerintah yang berwenang, setiap afiliasi Home
                  Credit dan/atau setiap pihak ketiga lainnya termasuk, namun
                  tidak terbatas pada Lembaga pencatatan aset, mitra penerima
                  pengalihan pembiayaan atau pengalihan hak tagih atau penyedia
                  jasa penagihan, Notaris, penyedia jasa pembayaran, penyedia
                  jasa riset, penyelenggara jaminan sosial, Penyelenggara
                  Sertifikasi Elektronik, penyelenggara sistem elektronik,
                  penyelenggara transaksi elektronik, perusahaan asuransi,
                  perusahaan perbankan, perusahaan penyedia layanan penyimpanan
                  dokumen, perusahaan penyedia layanan telekomunikasi di
                  Indonesia, dan/atau penyedia jasa lainnya yang terikat secara
                  resmi dan sah dengan Home Credit (”Pihak Ketiga”).
                </Text>
                <Text>
                  Kami membagikan Data Pribadi Anda dengan Pihak Ketiga tersebut
                  untuk tujuan, termasuk namun tidak terbatas pada, hal-hal
                  sebagai berikut:
                </Text>

                <ol type="1" style={{ marginLeft: "32px" }}>
                  <li>
                    Mengumpulkan dan menyediakan Data Pribadi kepada Pihak
                    Ketiga untuk keperluan identifikasi, penilaian risiko atau
                    kemampuan, dan/atau proses terkait lainnya yang dibutuhkan
                    dalam hal penyediaan layanan atau jasa keuangan seperti
                    produk perbankan, pembiayaan, non-pembiayaan, asuransi
                    dan/atau layanan/jasa keuangan lainnya yang disediakan oleh
                    Pihak Ketiga.
                  </li>
                  <li>
                    Mengumpulkan dan menyediakan Data Pribadi kepada Pihak
                    Ketiga, yang berstatus sebagai kreditur bersama, untuk
                    kepentingan pencairan pembiayaan, yang sebelumnya telah
                    menerima pengungkapan Data Pribadi dalam rangka pelaksanaan
                    uji tuntas terhadap status Anda selama menjadi debitur dari
                    kreditur manapun, diantaranya secara khusus tentang: (i)
                    status hapus buku dan/atau hapus tagih sampai dengan
                    dialihkannya piutang tersebut kepada pihak lainnya; dan/atau
                    (ii) status keterlibatan dalam restrukturisasi hutang.
                  </li>
                  <li>
                    Mengumpulkan dan menyediakan Data Pribadi Anda kepada Pihak
                    Ketiga dalam rangka melaksanakan fungsi pencegahan
                    <i>fraud</i> dan/atau pelaksanaan strategi <i>anti-fraud</i>
                    .
                  </li>
                  <li>
                    Melakukan verifikasi yang ditujukan untuk menilai kapasitas
                    Anda dalam mendapatkan program perlindungan, termasuk
                    menyediakan Data Pribadi Anda untuk kepentingan pengajuan
                    klaim atas program perlindungan yang disediakan oleh Pihak
                    Ketiga.
                  </li>
                  <li>
                    Mengumpulkan dan menyediakan Data Pribadi Anda kepada Pihak
                    Ketiga dalam rangka melaksanakan fungsi penagihan untuk
                    menjaga riwayat pembayaran Anda.
                  </li>
                  <li>
                    Menyimpan seluruh bentuk komunikasi apapun antara Anda dan
                    Home Credit melalui media komunikasi yang Kami sediakan,
                    yang kemudian diteruskan kepada Pihak Ketiga untuk disimpan,
                    diolah dan diubah menjadi sebuah naskah atau teks yang mampu
                    dilafalkan, dibaca dan dipahami serta dicatat dalam sistem
                    atau <i>database</i> Kami.
                  </li>
                  <li>
                    Melakukan verifikasi, penilaian risiko, identifikasi
                    dan/atau analisa terhadap setiap aktivitas, pola perilaku
                    transaksi, skala upah, data demografis, keikutsertaan dalam
                    jaminan sosial, termasuk kebiasaan dan perilaku penggunaan
                    berbagai layanan yang tersedia pada aplikasi dompet
                    elektronik (<i>electronic wallet</i>), aplikasi penyedia
                    jasa pembayaran, aplikasi perdagangan elektronik (
                    <i>electronic commerce</i>) atau aplikasi penyedia transaksi
                    elektronik lainnya dan/atau pada perilaku penggunaan layanan
                    telekomunikasi (termasuk durasi penggunaannya) dalam rangka
                    memastikan pemberian fasilitas pembiayaan sesuai dengan
                    profil dan karakteristik Pengguna atau Konsumen.
                  </li>
                  <li>
                    Mengumpulkan data, dokumen, atau informasi kendaraan yang
                    mengandung Data Pribadi untuk didaftarkan kepada Pihak
                    Ketiga dalam rangka pembebanan jaminan/agunan sesuai dengan
                    sertifikat fidusia yang diterbitkan sebagai upaya mitigasi
                    risiko atas fasilitas pembiayaan yang diberikan oleh Home
                    Credit kepada Anda sesuai peraturan perundang-undangan yang
                    berlaku, serta untuk menyimpan dan mengembalikan Data
                    Pribadi dengan tunduk pada syarat dan ketentuan dalam
                    perjanjian pembiayaan Anda.
                  </li>
                  <li>
                    Mengungkapkan dan/atau membagikan Data Pribadi kepada Pihak
                    Ketiga yang menerima pengalihan hak dan kewajiban, termasuk
                    hutang atau tagihan, yang timbul dari perjanjian pembiayaan
                    yang Anda tandatangani, dengan tunduk pada syarat dan
                    ketentuan sebagaimana diatur dalam perjanjian pembiayaan dan
                    peraturan perundang-undangan yang berlaku.
                  </li>
                  <li>
                    Mengumpulkan dan mengungkapkan Data Pribadi Anda dalam
                    rangka persyaratan penyimpanan oleh, dan dalam rangka
                    pelaporan internal kepada, perusahaan induk, perusahaan
                    terafiliasi, pemilik utama atau entitas yang secara langsung
                    atau tidak langsung dikendalikan oleh pihak yang sama yang
                    mengendalikan Home Credit.
                  </li>
                  <li>
                    Menyelenggarakan kegiatan penelitian, analisis, menghasilan
                    statistik dan pengembangan yang secara khusus ditujukan
                    untuk survei, pengembangan produk dan/atau layanan,
                    sekaligus menganalisa pengalaman dan kepuasan Anda selama
                    menggunakan layanan Home Credit termasuk layanan/jasa
                    keuangan lainnya.
                  </li>
                  <li>
                    Melakukan verifikasi dalam rangka penerbitan Sertifikat
                    Elektronik oleh Penyelenggara Sertifikasi Elektronik, yang
                    dilakukan dengan cara mengindentifikasi dan memeriksa
                    kesesuaian Data Pribadi dengan data yang tercatat pada
                    sistem pangkal data (<i>database</i>) milik suatu instansi
                    pemerintah yang berwenang dan berhak mengeluarkan informasi
                    hasil penilaian atas kesesuaian atau keakuratan Data
                    Pribadi.
                  <br/>
                    Yang dimaksud dengan Penyelenggara Sertifikasi Elektronik
                    adalah badan hukum yang berfungsi sebagai pihak yang layak
                    dipercaya, yang memberikan dan mengaudit Sertifikat
                    Elektronik. Sertifikat Elektronik adalah sertifikat yang
                    bersifat elektronik yang memuat tanda tangan elektronik dan
                    identitas yang menunjukkan status subjek hukum para pihak
                    dalam transaksi elektronik yang dikeluarkan oleh
                    Penyelenggara Sertifikasi Elektronik.
                  </li>
                  <li>
                    Mengumpulkan dan mengungkapkan Data Pribadi Anda dalam
                    rangka pelaporan eksternal kepada lembaga dan/atau otoritas
                    pemerintah yang berwenang, untuk memenuhi ketentuan
                    peraturan perundang-undangan, termasuk persyaratan
                    perpajakan dan/atau persyaratan penyimpanan data.
                  </li>
                  <li>
                    Untuk mematuhi semua kewajiban berdasarkan peraturan
                    perundang-undangan yang berlaku, melakukan pemeriksaan audit
                    (internal dan eksternal), pelaksanaan uji tuntas dan dalam
                    rangka penegakan hukum.
                  </li>
                </ol>
                <Text>
                  Pihak Ketiga tersebut di atas memiliki akses ke Data Pribadi
                  Anda hanya untuk melaksanakan tugas-tugas sehubungan dengan
                  Tujuan Penggunaan Data Pribadi sebagaimana diuraikan dalam
                  butir 2 di atas dan berkewajiban untuk tidak mengungkapkan
                  atau menggunakan informasi atau data pribadi tersebut untuk
                  tujuan lain.
                </Text>
              </li>

              <li>
                <Heading margin={["8px 0", "8px 0"]}>
                  <b>Penyimpanan Data</b>
                </Heading>
                <Text>
                  Kami akan menyimpan Data Pribadi berikut data hasil olahan dan
                  analisisnya selama diperlukan untuk memenuhi tujuan yang
                  ditetapkan dalam Kebijakan Privasi ini atau disimpan mengikuti
                  masa retensi minimal 10 (sepuluh) tahun sejak terakhir kali
                  Anda menjadi Pengguna dan/atau sebagaimana dipersyaratkan
                  berdasarkan peraturan perundang-undangan yang berlaku.
                </Text>
                <Text>
                  Selama periode tersebut Home Credit dapat memperbaharui data
                  Anda secara berkala. Anda mengetahui bahwa aktivitas ini dapat
                  menggunakan paket data internet Anda.
                </Text>
                <Text>
                  Kami akan menghapus dan/atau menganonimkan Data Pribadi
                  Pengguna yang ada di bawah kendali Kami apabila (i) Data
                  Pribadi Pengguna tidak lagi diperlukan untuk memenuhi tujuan
                  dari pengumpulannya; (ii) berakhirnya masa retensi dan (iii)
                  penyimpanan tidak lagi diperlukan untuk tujuan kepatuhan
                  menurut ketentuan Peraturan Perundang-undangan yang berlaku.
                </Text>
                <Text>
                  Mohon diperhatikan bahwa masih ada kemungkinan bahwa beberapa
                  Data Pribadi Anda disimpan atau dikuasai oleh pihak lain
                  termasuk institusi pemerintah dengan cara tertentu. Dalam hal
                  Kami membagikan Data Pribadi Anda kepada institusi pemerintah
                  yang berwenang dan/atau institusi lainnya yang dapat ditunjuk
                  oleh pemerintah yang berwenang atau memiliki kerja sama dengan
                  Kami, Anda menyetujui dan mengakui bahwa penyimpanan Data
                  Pribadi Anda oleh institusi terkait akan mengikuti kebijakan
                  penyimpanan data masing-masing institusi tersebut.
                </Text>
              </li>

              <li>
                <Heading margin={["8px 0", "8px 0"]}>
                  <b>Keamanan Data</b>
                </Heading>
                <Text>
                  Home Credit dalam mengumpulkan dan menggunakan informasi atau
                  data pribadi akan menerapkan semua tindakan keamanan fisik,
                  teknis dan organisasi yang sesuai, dan mengamati praktik
                  terbaik industri untuk mencegah terjadinya insiden keamanan
                  dan untuk melindungi informasi atau data pribadi Anda dari
                  pengungkapan atau penyalahgunaan secara tidak sah dan
                  menginformasikan kepada Anda tanpa penundaan yang tidak wajar
                  apabila Kami mengindikasikan adanya pelanggaran keamanan data.
                </Text>
              </li>

              <li>
                <Heading margin={["8px 0", "8px 0"]}>
                  <b>Hak Anda Sebagai Pengguna</b>
                </Heading>
                <Text>
                  Anda dapat (i) melengkapi, memperbarui dan/atau memperbaiki,
                  (ii) mendapatkan informasi atau akses, dan/atau (iii)
                  mengakhiri, menunda atau membatasi, menarik persetujuan
                  penggunaan informasi atau data pribadi Anda, termasuk
                  mengajukan keberatan, penghapusan atau pemusnahan informasi
                  atau Data Pribadi tersebut kepada kami melalui layanan
                  pelanggan Home Credit, di mana pelaksanaan atas pengajuan Anda
                  akan kami lakukan sesuai dengan prosedur dan kebijakan
                  internal Home Credit yang berlaku dengan tunduk pada peraturan
                  perundang-undangan yang berlaku, termasuk peraturan
                  perundang-undangan mengenai pelindungan data pribadi.
                </Text>
                <Text>
                  Ketika kami perlu mengumpulkan Data Pribadi berdasarkan
                  peraturan perundang-undangan yang berlaku, atau berdasarkan
                  ketentuan sebuah perjanjian yang Kami miliki dengan Anda, dan
                  Anda memilih untuk tidak menyediakan Data Pribadi tersebut
                  atau menyediakan Data Pribadi yang tidak lengkap kepada Kami
                  saat diminta, Kami mungkin tidak dapat menyediakan layanan dan
                  melaksanakan perjanjian yang Kami sepakati dengan Anda.
                </Text>
              </li>

              <li>
                <Heading margin={["8px 0", "8px 0"]}>
                  <b>Perubahan Kebijakan Privasi Ini</b>
                </Heading>
                <Text>
                  Kami dapat memperbaharui Kebijakan Privasi ini dari waktu ke
                  waktu. Dalam hal Kami memutuskan untuk memperbarui Kebijakan
                  Privasi ini, Kami akan memberitahu Anda tentang perubahan
                  tersebut melalui kanal resmi Kami, antara lain website,{" "}
                  <i>push notification</i> pada Aplikasi dan/atau melalui alamat
                  e-mail Anda yang tercantum dalam akun Anda. Anda setuju bahwa
                  (i) Anda bertanggung jawab untuk memeriksa Kebijakan Privasi
                  ini secara berkala untuk melihat apabila terdapat suatu
                  perubahan atas Kebijakan Privasi ini, dan (ii) bahwa dengan
                  Anda terus menggunakan Aplikasi Kami, berkomunikasi dengan
                  Kami, atau mengakses dan menggunakan layanan setelah adanya
                  perubahan apapun terhadap Kebijakan Privasi ini akan dianggap
                  sebagai persetujuan Anda terhadap Kebijakan Privasi ini dan
                  segala perubahannya.
                </Text>
                <Text>
                  Apabila suatu bagian dari Kebijakan Privasi tidak dapat
                  dipakai, maka bagian tersebut tidak mempengaruhi keabsahan dan
                  keberlakuan ketentuan lainnya. Bagian yang tidak berlaku
                  tersebut akan digantikan dengan ketentuan yang sah.
                </Text>
              </li>

              <li>
                <Heading margin={["8px 0", "8px 0"]}>
                  <b>Hubungi Kami</b>
                </Heading>
                <Text>
                  Jika anda memiliki pertanyaan tentang Kebijakan Privasi ini
                  atau jika Anda ingin mendapatkan akses, meminta penghapusan,
                  melakukan koreksi dan/atau mendapatkan hak-hak lainnya
                  terhadap Data Pribadi Anda, silakan hubungi layanan pelanggan
                  (<i>customer care</i>) kami di: (021) 29539600 atau melalui
                  email <a style={{color:"var(--color-red)"}} href="mailto:care@homecredit.co.id">care@homecredit.co.id</a> atau <a style={{color:"var(--color-red)"}} href="mailto:id.dpo@homecredit.co.id">id.dpo@homecredit.co.id</a>.
                </Text>
              </li>
            </ol>
          </Box>

          <Text marginBottom={["8px", "16px"]} fontWeight="bold">
            © Hak Cipta 2024 PT Home Credit Indonesia
          </Text>
        </Box>
      </UIProvider>
    </Layout>
  );
};

kebijakanPrivasi.getInitialProps = ({ asPath }) => {
  const pageTitle = kebijakanPrivasiMeta.title;
  const descriptionSEO = kebijakanPrivasiMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};

export default kebijakanPrivasi;
